<template>
  <button v-if="!link" :class="mode" >
    <slot></slot>
  </button>
  <router-link v-else :to="to" :class="mode">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      required: false,
      default: null
    },
    link: {
      type: Boolean,
      required: false,
      default: false
    },
    to: {
      type: String,
      required: false,
      default: '/'
    },
    isMobile:{
      default:false
    }
  }
}
</script>

<style scoped>
button,
a {
  text-decoration: none;
  padding: 0.75rem 0.5rem;
  font: inherit;
  border: 1px solid #3a0061;
  color: white;
  cursor: pointer;  
  display: inline-block;
  background-color:  #3a0061;  
}

a:hover,
a:active,
button:hover,
button:active {
  background-color: #270041;

}

.flat {
  background-color: #3a0061;
  border-radius: 30px;
  color: #3a0061;
  border: none;
}
.red{
  width:100%;
  border: 1px solid #b72e00;
  background-color: #c30;
  margin-bottom: 17px;
  font-weight:bold;
  padding: 1.2rem 1.5rem;
}
.red:hover{
  background:#b72e00;  
}
.red_sm{
  width:100%;
  border: 1px solid #b72e00;
  background-color: #c30;
  margin-bottom: 17px;
  font-weight:bold;
  padding: 0.5rem 1.5rem;
}
.red_sm:hover{
  background:#b72e00;  
}
.skyblue{
  width:100%;
  height:100%;
  background-color:#2a95bf;
  border: none;
}
.skyblue:hover{
  background-color:#2a86b5;
}

.orange{
  width:100%;
  height:100%;
  background-color:#f25116;
  border: none;
}
.orange:hover{
  background-color:#c84718;
}

.orange2{  
  background-color:#f25116;
  border: none;
}
.orange2:hover{
  background-color:#c84718;
}

.darkblue{
  width:100%;
  height:100%;
  background-color:#1a2f6a;
  border: none;
}
.darkblue:hover{
  background-color:#0c1031;
}

.darkred{
  width:100%;
  height:100%;
  background-color:#5f121b;
  border: none;
}
.darkred:hover{
  background-color:#310c1c;
}

.outline_gray{
  border: 2px solid #d1d1d1;
  width:100%;
  height:100%;
  background-color:#fff;
  color: #000;  
}
.outline_gray:hover{
  background-color:#d1d1d1;
}

.outline {
  background-color: #3a0061;
  border-radius: 30px;
  border-color: #270041;
  color: #270041;
}
.outline-red{
  padding: 14px 25px 13px;
  border: 1px solid #ed2026;
  background-color: #fff;
  color: #ed2026;
  font-size: 12px;
}
.outline-red:hover{
  background: #ed2026;
  color:#fff;
}
.flat:hover,
.flat:active,
.outline:hover,
.outline:active {
  background-color: #edd2ff;
}
button:focus { outline: none; }
.disable{
  border: 1px solid #d1d1d1; 
  background-color:#fff;
  color: #d1d1d1;  
}
.disable:hover{
  border: 1px solid #d1d1d1; 
  background-color:#fff;
  color: #d1d1d1;   
}
</style>
